module.exports = __webpack_public_path__ + "img/copy_icon.4cffdc88.svg";